module.exports = __webpack_public_path__ + "mstile-310x150.png";


//////////////////
// WEBPACK FOOTER
// ./src/icon/mstile-310x150.png
// module id = 23
// module chunks = 0